import { z } from 'zod';
import { DEFAULT_TAG_COLOR } from '@/features/dashboard/tags/types/tagColor.utils.ts';
import { HEX_COLOR_REGEX } from '@/schemas/hexColor.ts';

export const tagSchema = z.object({
  name: z
    .string()
    .min(1, 'Nazwa jest wymagana')
    .max(64, 'Nazwa może mieć max 64 znaki'),
  color: z.string().regex(HEX_COLOR_REGEX, 'Wybierz poprawny kolor'),
});

export type TagFormData = z.infer<typeof tagSchema>;
export type TagFormInput = z.input<typeof tagSchema>;

export const tagDefaultValues: TagFormInput = {
  name: '',
  color: DEFAULT_TAG_COLOR,
};
